import { API_BASE_URL } from '../config';

const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1', '0.0.0.0']);

const normalizeBase = (base) => {
  if (!base || typeof base !== 'string') return '';
  return base.trim().replace(/\/+$/, '');
};

const normalizePath = (value) => {
  let normalized = String(value || '').trim();
  if (!normalized) return '';

  normalized = normalized.replace(/\\/g, '/');

  if (normalized.startsWith('file://')) {
    try {
      normalized = new URL(normalized).pathname || normalized;
    } catch (_error) {
      // keep original normalized value
    }
  }

  const uploadsIndex = normalized.toLowerCase().indexOf('/uploads/');
  if (uploadsIndex >= 0) {
    normalized = normalized.slice(uploadsIndex + 1);
  }

  if (/^[A-Za-z]:\//.test(normalized)) {
    const filename = normalized.split('/').pop();
    if (filename) {
      normalized = `uploads/profiles/${filename}`;
    }
  }

  const compact = normalized.replace(/^\/+/, '');
  if (compact && !compact.includes('/') && /^[A-Za-z0-9._-]+$/.test(compact)) {
    normalized = `uploads/profiles/${compact}`;
  }

  normalized = normalized
    .replace(/\.jped$/i, '.jpeg')
    .replace(/\.jpe$/i, '.jpeg');

  return normalized.replace(/^\/+/, '').replace(/\/+/g, '/');
};

const rewriteAbsoluteLocalhostUrl = (rawUrl, apiBase) => {
  if (!apiBase) return rawUrl;
  try {
    const parsed = new URL(rawUrl);
    if (!LOCAL_HOSTNAMES.has(parsed.hostname.toLowerCase())) {
      return rawUrl;
    }
    return `${apiBase}${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch (_error) {
    return rawUrl;
  }
};

export const resolveBackendAssetUrl = (value, options = {}) => {
  if (!value) return null;
  const raw = String(value).trim();
  if (!raw) return null;
  if (raw.startsWith('data:')) return raw;

  const apiBase = normalizeBase(options.apiBaseUrl ?? API_BASE_URL);

  if (/^https?:\/\//i.test(raw)) {
    return rewriteAbsoluteLocalhostUrl(raw, apiBase);
  }

  let path = normalizePath(raw);
  if (options.assumeProfilesDir && !/^(uploads\/|api\/)/i.test(path)) {
    path = `uploads/profiles/${path}`;
  }

  if (!apiBase) {
    return `/${path}`;
  }
  return `${apiBase}/${path}`;
};
